import React from 'react';
import { createPortal } from 'react-dom';

interface TimestampTooltipProps {
  time: number;
  x: number;
  y: number;
  isDarkMode: boolean;
  label?: string;
}

// Helper function to format time (handles hours for long content)
const formatTime = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hours > 0) {
    return `${hours}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

const TimestampTooltip: React.FC<TimestampTooltipProps> = ({
  time,
  x,
  y,
  isDarkMode,
  label
}) => {
  const tooltipContent = (
    <div
      className="fixed z-[9999] pointer-events-none"
      style={{
        left: x,
        top: y - 36,
        transform: 'translateX(-50%)'
      }}
    >
      <div
        className={`px-2.5 py-1.5 rounded-md text-xs font-mono shadow-lg ${
          isDarkMode
            ? 'bg-gray-800 text-white border border-gray-700'
            : 'bg-gray-900 text-white'
        }`}
      >
        {label && (
          <span className="text-pink-400 mr-1.5">{label}:</span>
        )}
        <span className="font-semibold">{formatTime(time)}</span>
      </div>
      {/* Arrow pointing down */}
      <div
        className="absolute left-1/2 -translate-x-1/2 -bottom-1.5"
        style={{
          width: 0,
          height: 0,
          borderLeft: '6px solid transparent',
          borderRight: '6px solid transparent',
          borderTop: isDarkMode ? '6px solid rgb(31, 41, 55)' : '6px solid rgb(17, 24, 39)'
        }}
      />
    </div>
  );

  // Use portal to render at document body level for proper z-index stacking
  return createPortal(tooltipContent, document.body);
};

export default TimestampTooltip;
